var jCube = require('./core'),
    vars = require('./variables');

// event attach jQuery style / trigger  since 1.2.0
jCube.fn.on = function (eventFullName, selector, callback, _one) {
    var _this = this;

    if (!jCube.isString(eventFullName)) {
        for (var key in eventFullName) {
            this.on(key, selector, eventFullName[key]);
        }

        return this;
    }

    if (jCube.isFunction(selector)) {
        callback = selector;
        selector = '';
    }

    jCube.each(jCube.h.getSplitValues(eventFullName), function (i, eventFullName) {
        var _a = jCube.h.parseEventName(jCube.h.getEventNameBubbling(eventFullName)),
            name = _a[0],
            namespaces = _a[1];

        _this.each(function (i, ele) {
            var finalCallback = function finalCallback(event) {
                if (event.namespace && !jCube.h.hasNamespaces(namespaces, event.namespace.split(vars.eventsNamespacesSeparator))) return;
                var thisArg = ele;

                if (selector) {
                    var target = event.target;

                    while (!jCube.h.matches(target, selector)) {
                        //TSC
                        if (target === ele) return;
                        target = target.parentNode;
                        if (!target) return;
                    }

                    thisArg = target;
                    event.__delegate = true;
                }

                if (event.__delegate) {
                    Object.defineProperty(event, 'currentTarget', {
                        configurable: true,
                        get: function get() {
                            return thisArg;
                        }
                    });
                }

                var returnValue = callback.call(thisArg, event, event.data); //TSC

                if (_one) {
                    jCube.h.removeEvent(ele, name, namespaces, selector, finalCallback); //TSC
                }

                if (returnValue === false) {
                    event.preventDefault();
                    event.stopPropagation();
                }
            };

            finalCallback.guid = callback['guid'] = callback['guid'] || jCube.guid++; //TSC

            jCube.h.addEvent(ele, name, namespaces, selector, finalCallback); //TSC
        });
    });

    return this;
};

jCube.fn.off = function (eventFullName, selector, callback) {
    var _this = this;

    if (eventFullName === undefined) {
        this.each(function (i, ele) {
            return jCube.h.removeEvent(ele);
        });
    } else {
        if (jCube.isFunction(selector)) {
            callback = selector;
            selector = '';
        }

        jCube.each(jCube.h.getSplitValues(eventFullName), function (i, eventFullName) {
            var _a = jCube.h.parseEventName(jCube.h.getEventNameBubbling(eventFullName)),
                name = _a[0],
                namespaces = _a[1];

            _this.each(function (i, ele) {
                return jCube.h.removeEvent(ele, name, namespaces, selector, callback);
            }); //TSC

        });
    }

    return this;
};

jCube.fn.one = function (eventFullName, selector, callback) {
    return this.on(eventFullName, selector, callback, true); //TSC
};

jCube.fn.ready = function (callback) {
    var finalCallback = function() {
        return callback(jCube);
    };

    if (vars.doc.readyState !== 'loading') {
        setTimeout(finalCallback);

    } else {
        vars.doc.addEventListener('DOMContentLoaded', finalCallback);
    }

    return this;
};

jCube.fn.trigger = function (eventFullName, data) {
    var evt;

    if (jCube.isString(eventFullName)) {
        var _a = jCube.h.parseEventName(eventFullName),
            name_1 = _a[0],
            namespaces = _a[1],
            type = vars.eventsMouseRe.test(name_1) ? 'MouseEvents' : 'HTMLEvents';

        evt = vars.doc.createEvent(type);
        evt.initEvent(name_1, true, true);
        evt.namespace = namespaces.join(vars.eventsNamespacesSeparator);

    } else {
        evt = eventFullName;
    }

    evt.data = data;
    var isEventFocus = evt.type in vars.eventsFocus;
    return this.each(function (i, ele) {
        if (isEventFocus && jCube.isFunction(ele[evt.type])) {
            ele[evt.type]();
        } else {
            ele.dispatchEvent(evt);
        }
    });

    // return this;
};

/**
 * TODO: Part of code is same as trigger()
 * TODO: The .triggerHandler( "event" ) method will not call .event() on the element it is triggered on.
 *       This means .triggerHandler( "submit" ) on a form will not call .submit() on the form.
 */
jCube.fn.triggerHandler = function( eventFullName, data ) {
    var evt;

    if (jCube.isString(eventFullName)) {
        var _a = jCube.h.parseEventName(eventFullName),
            name_1 = _a[0],
            namespaces = _a[1],
            type = vars.eventsMouseRe.test(name_1) ? 'MouseEvents' : 'HTMLEvents';

        evt = vars.doc.createEvent(type);
        evt.initEvent(name_1, true, true);
        evt.namespace = namespaces.join(vars.eventsNamespacesSeparator);

    } else {
        evt = eventFullName;
    }

    evt.data = data;
    var isEventFocus = evt.type in vars.eventsFocus;

    if(this.length > 0) {
        var ele = this[0];
        if (isEventFocus && jCube.isFunction(ele[evt.type])) {
            return ele[evt.type]();
        } else {
            return ele.dispatchEvent(evt);
        }
    }

    return undefined;
};